define(function ( require ) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var LPTModel = require('vendor/Backbone/LPTModel');
    var AppConfig = require('config/application');

    return LPTModel.extend({
        initialize: function () {
            //this.on('change:owner_id', this.checkObservers, this);
        },

        urlRoot: function () {
            return AppConfig.host + '/rest/tasks';
        },

        transformDate: function () {
            var end, endDate, endTime;
            if ($.type(this.get('end_time')) != 'string' || $.type(this.get('end_date')) != 'string') {
                end = app.Utils.moment.unix(this.get('date_end'));

                endDate = end.format(AppConfig.locale.date_format);
                endTime = end.format(AppConfig.locale.time_format_min);

                if (!this.get('date_end')) {
                    endTime = '';
                    endDate = '';
                }

                this.set({
                    end_date: endDate,
                    end_time: endTime
                }, {silent: true});
            }
        },

        getStartDateTask: function () {
            var dateStart = app.Utils.moment.unix(this.get('date_start'));

            if (dateStart) {
                return dateStart.utc().format('YYYY-MM-DD HH:mm');
            }
        },

        getEndDateTask: function () {
            var dateEnd = app.Utils.moment.unix(this.get('date_end'));

            if (dateEnd) {
                return dateEnd.utc().format('YYYY-MM-DD HH:mm');
            }
        },

        getUtcOffset: function () {
            var userTimezoneId = app.Models.User.get('timezone');
            var userTimezoneObj = _.findWhere(app.Timezone.attributes, {id: userTimezoneId});
            var userTimezone = userTimezoneObj.timezone;

            return app.Utils.moment.tz(userTimezone).utcOffset();
        },

        getTimeNowWithTimezone: function () {
            var timeNowWithTimezone = app.Utils.moment().utcOffset(this.getUtcOffset());
            return timeNowWithTimezone.format('YYYY-MM-DD HH:mm');
        },

        getStartDateTaskWithTimezone: function () {
            var dateStart = app.Utils.moment
                .unix(this.get('date_start'))
                .utcOffset(this.getUtcOffset());

            if (dateStart) {
                return dateStart.format('YYYY-MM-DD HH:mm');
            }
        },

        getEndDateTaskWithTimezone: function () {
            var dateEnd = app.Utils.moment
                .unix(this.get('date_end'))
                .utcOffset(this.getUtcOffset());
            if (dateEnd) {
                return dateEnd.format('YYYY-MM-DD HH:mm');
            }
        },

        setDateTask: function ( dateStart, dateEnd ) {
            var dateStartUtc = dateStart.subtract(this.getUtcOffset(), 'minutes');
            var dateEndUtc = dateEnd.subtract(this.getUtcOffset(), 'minutes');

            this.set('date_start', dateStartUtc.unix());
            this.set('date_end', dateEndUtc.unix());
        },


        setObserversId: function () {
            var observersList = this.get('observersList') || [],
                observers = _.pluck(observersList, 'id');

            this.set('observers', observers);
        },

        defaults: {
            title: '',
            project: 0,
            info: '',
            type: 0, // 0 - public, 1 - private
            labels: [],
            observers: [],
            date_start: 0,
            date_end: 0,
            complete: false,
            repeat: false,
            owner_id: 0,
            remind: false,
            remind_time: 'in_time',
            remind_method: ['sms', 'email', 'popup'],
            files: [],
            repeat_pn: true,
            repeat_vt: false,
            repeat_sr: false,
            repeat_ct: false,
            repeat_pt: false,
            repeat_sb: false,
            repeat_vs: false,
            repeat_every: 'month',
            repeat_month_advansed: 'day_of_month',
            repeat_time: '1',
            repeat_until: '',
            expanded: false,
            visibility: 2
        },

        validation: {
            title: function () {
                if (_.isEmpty(this.get('title'))) {
                    return 'Необходимо ввести название задачи';
                }
            },
            date_start: function ( value ) {
                var isChange = value !== this.previous('date_start');
                var isExpired = app.Utils.moment(this.getStartDateTaskWithTimezone())
                    .isBefore(this.getTimeNowWithTimezone());
                var checkText = 'Задача не может быть создана в прошедшем времени';

                // когда модель новая всегда делаем проверку
                if (isExpired && this.isNew()) {
                    return checkText;
                }
                // если модель созданная, смотрим менялось ли время, если да то проверка
                if (!this.isNew() && isExpired && isChange) {
                    return checkText;
                }
            },
            date_end: function () {
                var dateStart = app.Utils.moment(this.getStartDateTaskWithTimezone());
                var dateEnd = app.Utils.moment(this.getEndDateTaskWithTimezone());
                var difference = dateEnd.diff(dateStart, 'minutes');
                var isMore30Minutes = Math.sign(difference) === -1 || Math.sign(difference) === 0
                    ? false
                    : difference >= 30;

                if (!isMore30Minutes) {
                    return 'Минимальное время задачи 30 минут';
                }
            }
        },

        //checkObservers: function () {
        //    var observers = this.get('observers'),
        //        ownerId = this.get('owner_id'),
        //        owner = app.Collections.StaffList.get(ownerId),
        //        index = observers.indexOf(ownerId);
        //
        //    this.set({
        //        owner_name: owner.get('name'),
        //        owner_type: owner.get('type'),
        //        owner_id_real: owner.get('eid')
        //    });
        //
        //    if (index != -1) {
        //        this.set('observers', _.without(observers, ownerId));
        //        this.trigger('observersUpdated');
        //    }
        //}
    });
});